/*export class User {
    id??: string;
    email?: string;
}*/

import { Region } from '../../../model/region.model';
import { Organization } from '../../common-components/organizations/model/organization.model';
import { SchoolDistrict } from '../../../model/schoolDistrict.model';
import { TelephoneNumber } from './telephonenumber';

export class UserToken {
    user?: User;
    token?: string;
    msg?: Msg;
}

export class User {
    ID?: number;
    PERSONS_ID?: number;
    USER_ID?: string;
    PASSWORD?: null;
    EMAIL_ADDRESS?: string;
    WORK_TITLE?: string;

    PERSON?: PERSON;
    USER_ROLES?: USERROLESEntity[] | null;
    LOGIN_DETAIL_SESSIONS?: LOGINDETAILSESSIONSEntity[] | null;
    LOGIN_AUDITS?: LOGINAUDITSEntity[] | null;
    LOGIN_DETAIL_STATUS?: LoginDetailStatus[] | null;
    REGION?: Region;
    TELEPHONE_NUMBERS?: TelephoneNumber[] | null;
    WORKS_FOR?: Organization | null;
    //WORK_ADDRESSES?: Address;
    LOGIN_DETAILS_CREATION?: LOGINDETAILSCREATION[] | null;
    LOGIN_DETAIL_PASSWORD_RECOVERIES?: LOGINDETAILPASSWORDRECOVERy[] | null;
    SCHOOL_DISTRICTS?: SchoolDistrict[];
    filter?: string[];
    hasSession?: string;
}
export class PERSON {
    ID?: number;
    PARTIES_ID?: number;
    LAST_NAME?: string;
    FIRST_NAME?: string;
    MIDDLE_INITIAL?: string;
    PREFIX?: null;
    SUFFIX?: null;
    PARTy?: PARTy;
    SECOND_LAST_NAME?: string;
}
export class PARTy {
    ID?: number;
}
export class USERROLESEntity {
    ID?: number;
    ROLES_ID?: number;
    ROLE?: ROLE;
}
export class ROLE {
    ID?: number;
    NAME?: string;
}
export class LOGINDETAILSESSIONSEntity {
    ID?: number;
    EXPIRATION_TIME?: string;
    LOGIN_AUDITS_ID?: number;
    LOGIN_AUDITS?: null;
}
export class LOGINAUDITSEntity {
    ID?: number;
    LOGIN_TIME?: string;
    LOGOUT_TIME?: null;
}
export class Msg {
    MSG?: string;
    SUCCESS?: boolean;
    TOKEN_EXPIRED?: boolean;
    MOU_REQUIRED?: boolean;
    ROB_REQUIRED?: boolean;
    PASSWORD_CHANGE_REQUIRED?: boolean;
    OTHER_SESSIONS_ACTIVE?: number;
    MAX_SESSIONS_ALLOWED?: number;
}

export class LoginDetailStatus {
    ID?: number;
    LOGIN_DETAILS_ID?: number;
    LOGIN_DETAIL_STATUS_TYPES_ID?: number;
    DESCRIPTION?: string;
    CREATED_BY?: string;
    CREATED_DATE?: Date;
    MODIFIED_BY?: string;
    MODIFIED_DATE?: Date;

    LOGIN_DETAIL_STATUS_TYPES?: LoginDetailStatusTypes;
}

export class LoginDetailStatusTypes {
    ID?: number;
    NAME?: string;
    DESCRIPTION?: string;
    CREATED_BY?: string;
    CREATED_DATE?: Date;
    MODIFIED_BY?: string;
    MODIFIED_DATE?: Date;
}

export class LOGINDETAILPASSWORDRECOVERy {
    ID: number;
    EMAIL_CONFIRMATION_CODE: string;
}

export class LOGINDETAILSCREATION {
    ID: number;
    EMAIL_CONFIRMATION_CODE: string;
}
